interface SpinnerIconProps {
    className?: string;
    iconClassName?: string;
    iconName?: string;
}

const SpinnerIcon = (props: SpinnerIconProps) => {
    const { className, iconClassName, iconName = 'fa-circle-notch' } = props;

    return (
        <div id={'spinner-icon'} className={`spinner-icon ${className || ''}`}>
            <i className={`fas ${iconName} fa-spin fa-xs ${iconClassName || ''}`} />
        </div>
    );
};

export default SpinnerIcon;
